import Controller from '@ember/controller';
import { action, get } from '@ember/object';
import { service } from '@ember/service';
import { all } from 'rsvp';

export default class BillingDowngradeController extends Controller {
  @service router;

  get hasMultipleFlowsAtAnyLocation() {
    return all(this.model.locations.map((location) => location.hasNonProtectFlows)).then((res) => {
      return res.some(Boolean);
    });
  }

  @action
  cancel() {
    this.router.transitionTo('billing.plans');
  }

  @action
  confirm() {
    this.router.transitionTo('billing.confirm-downgrade', get(this.model, 'targetPlan.id'));
  }
}
